import { createStore } from 'vuex'

import { projects } from '@/data/projects'
import { employments } from '@/data/employments'
import { skills } from '@/data/skills'

export default createStore({
  state: {
    projects: projects,
    employments: employments,
    skills: skills,
    theme: 'night'
  },
  getters: {
    getAllProjects: state => state.projects,
    getAllEmployments: state => state.employments,
    getAllSKills: state => state.skills,
    getTheme: state => state.theme
  },
  mutations: {
    SET_THEME:(state, newTheme) => {
      state.theme = newTheme
    }
  },
  actions: {
    setTheme(context, theme){
      context.commit('SET_THEME', theme)
    }
  },
  modules: {
  }
})
